import { Component, EventEmitter, Input, Output, signal, ViewChild } from '@angular/core';
import { NgClass } from "../../../../node_modules/@angular/common/common_module.d-NEF7UaHr";

@Component({
  selector: 'AMore-sdk-ad-video-view',
  imports: [],
  templateUrl: './ad-video-view.component.html',
  styleUrl: './ad-video-view.component.scss'
})
export class AdVideoViewComponent {
  @ViewChild('media') media!: any;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() adData: any = {} as any;
  @Input() index: number = 0;

  private progressNum: number = -0.99;
  isAdClosed: boolean = false;
  isAdCompleted: boolean = false;
  rewarded: boolean = false;
  impressionTracked: boolean = false;

  ngOnInit() {
    this.isAdClosed = false;
  }

  public onClickEvent(event: any, action: string, callback?: any) {
    switch (action) {
      case 'on_ad_progress':
        if (Math.floor(this.media.nativeElement.currentTime % 2) === 0 && Math.floor(this.media.nativeElement.currentTime) !== this.progressNum) {
          this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
          this.progressNum = Math.floor(this.media.nativeElement.currentTime);
        }
        break;
      case 'on_ad_paused':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
        break;
      case 'on_ad_resumed':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
        break;
      case 'on_ad_error':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: { status_code: '500', message: 'video error' } });
        break;
      case 'on_ad_skip':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
        break;
      case 'on_ad_reward':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
        break;
      case 'on_ad_completed':
        this.isAdCompleted = true;
        this.pauseVideo();
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: { ...this.adData } });
        break;
      case 'on_ad_closed':
        this.isAdClosed = true;
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: { ...this.adData } });
        break;
      case 'on_ad_clicked':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: { url: this.adData.ads[this.index].clickUrl, action: "open_url" } });
        break;
      case 'on_ad_impression':
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
        break;
      default:
        this.onChangeEvent.emit({ action: action, progress: Math.floor(this.media.nativeElement.currentTime), data: {} });
        break;
    }
    // if (this.media.nativeElement.currentTime > 50 && this.media.nativeElement.currentTime < 51) {
    //   this.onChangeEvent.emit({ action: 'on_next_ad', data: {} });
    // } 
    if (this.adData && this.media.nativeElement.currentTime) {
      if ((this.media.nativeElement.currentTime / this.media.nativeElement.timeoutPercentage * 100) > 75 && (this.media.nativeElement.currentTime / this.media.nativeElement.timeoutPercentage * 100) < 75.5) {
        this.onChangeEvent.emit({ action: 'on_ad_time_out', data: {} });
      }
      // reward at percentage
      if (this.media.nativeElement.currentTime >= (this.adData.ads[this.index].creative.rewardPercentage / 100) * this.media.nativeElement.duration && !this.rewarded) {
        this.rewarded = true;
        this.onChangeEvent.emit({ action: 'on_ad_collect_reward', data: { reward: +this.adData.ads[this.index].creative.rewardPercentage + '%' } });
      }

      // impression at 2s
      if (this.media.nativeElement.currentTime >= 2 && !this.impressionTracked) {
        this.impressionTracked = true;
        this.onClickEvent(null, 'on_ad_impression');
      }
    }
  }

  playVideo() {
    if (!this.isAdClosed && !this.isAdCompleted) {
      this.media.nativeElement.play();
    }
  }

  pauseVideo() {
    this.media.nativeElement.pause();
  }
}
